export const SET_CURRENT_USER = '@@CURRENT_USER/SET_CURRENT_USER';